





































import { Component, Prop, Vue } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import eventBus from '@/utils/eventBus';
import MarketingCenterService from '@/api/MarketingCenterService';

@Component({ components: { Surface, Typography, Picture, FilledButton } })
export default class MarketingCenterDeleteModal extends Vue {
  @Prop(String) readonly postId?: string;
  @Prop(String) readonly gaContextPage!: string;
  service = new MarketingCenterService();
  loading: boolean = false;

  onClose() {
    eventBus.$emit('closeModal');
  }

  async deletePost() {
    try {
      if (this.postId) {
        this.loading = true;
        const response = await this.service.deletePost(this.postId);
        if (response.status === 200) {
          this.$notification('Successfully deleted', 'success');

          this.$analytics({
            eventCategory: `${this.gaContextPage} | Delete Post`,
            eventAction: 'click',
            eventLabel: 'Deleted post'
          });
        }
        this.onClose();
        this.$router.push('/marketing-center/social-media-templates');
        eventBus.$emit('marketingCenterPostDeletion');
      }
    } finally {
      this.loading = false;
    }
  }
}
